<template>
	<el-dialog :title="showTitle" :visible.sync="dialogAddShow" width="60%" :before-close="handleClose">
		<el-form :rules="userRules" label-position="right" ref="addForm" :model="addForm" label-width="70px" class="postForm">
			<el-form-item label="角色名:" label-width="100px" prop="roleName" class="notBlank" size="small">
				<el-input v-model="addForm.roleName" auto-complete="off" class="formItem" />
			</el-form-item>
			<el-form-item label="菜单权限:" label-width="100px" class="notBlank">
				<el-tree :data="purveiwDict" show-checkbox node-key="id" ref="tree" highlight-current :props="defaultProps"></el-tree>
			</el-form-item>
			<el-form-item label="页面功能:" label-width="100px" v-if="1==2">
								<el-select v-model="pageFunCodesArr" placeholder="请选择" size="small" multiple style="width: 95%;">
									<el-option v-for="item in pageFunCodesDict" :key="item.valuekey" :label="item.textkey"
										:value="item.valuekey">
									</el-option>
								</el-select>
				</el-form-item>
		</el-form>
		<div slot="footer" class="dialog-footer">
			<el-button  size="small" @click="handleClose()">取 消</el-button>
			<el-button type="primary" size="small" @click="handleSubmit()">确 定</el-button>
		</div>
	</el-dialog>
</template>
<script>
	export default {
		name: "addSave",
		props: ["showTitle", "dialogAddShow", "mid"],
		data() {
			const validateroleName = (rule, value, callback) => {
				if (value.length == 0 && !value) {
					callback(new Error("角色不能空"));
				} else {
					callback();
				}
			};
			return {
				addForm: {},
				purveiwDict: [],
				defaultProps: {
					children: "children",
					label: "label"
				},
				userRules: {
					/* roleName: [{
						required: true,
						message: "必须输入角色名",
						trigger: "change",
						validator: validateroleName
					}] */
				},
				pageFunCodesArr:[],
				pageFunCodesDict:[]
			};
		},
		watch: {
			dialogAddShow: {
				handler(newVal, oldVal) {
					if (newVal) {
						this.pageFunCodesArr=[]
						this.initData();
					}
				},
				deep: true
			}
		},
		methods: {
			initData() {
				this.$axios
					.get(
						"/backadmin/geteslroleinfo?id=" +
						this.mid +
						"&rnd=" +
						new Date().getTime()
					)
					.then(res => {
						this.addForm = res.data.data;
						if(this.addForm.pageFunCodes!=""){
							this.addForm.pageFunCodes.split(',').map(v=>{
								this.pageFunCodesArr.push(Number(v))
							})
						}
						else{
							this.pageFunCodesArr=[10,11]
						}

						this.loadDict();
					});
			},
			getChildCodeRow(purviewCode,childCodes){
				let rows = []
				return rows
				let nameArr = ["查询","新增", "编辑", "删除", "审批","导入","导出"]
				let codeArr=childCodes.split(',');
				for (let k = 0; k < codeArr.length; k++) {
					rows.push({
						id:purviewCode + "_"+codeArr[k],
						label: nameArr[Number(codeArr[k])],
						type: 2
					})
				}
				return rows
			},
			loadDict() {
				this.$axios
					.get("/comm/geteslpurviewdict?rnd=" + new Date().getTime())
					.then(res => {
						this.purveiwDict = [];
						for (let n = 0; n < res.data.data.length; n++) {
							let row = res.data.data[n];
							let currentRow = {
								id: row.moduleID,
								label: row.moduleName,
								type: 0,
								children: []
							};
							for (let k = 0; k < row.eslpurviewslist.length; k++) {
								currentRow.children.push({
									id: row.eslpurviewslist[k].purviewCode,
									label: row.eslpurviewslist[k].purviewName,
									type: 1,
									children:this.getChildCodeRow(row.eslpurviewslist[k].purviewCode,row.eslpurviewslist[k].childCodes)
								});
							}
							this.purveiwDict.push(currentRow);
						}
						if (this.addForm.purviewCodes) {
								this.$refs.tree.setCheckedKeys(
									this.addForm.purviewCodes.split(",")
								);
							}
						else{
							this.$refs.tree.setCheckedKeys([]);
						}
					});
			},
			handleClose() {
				this.$emit("getVisible", false);
			},
			handleSubmit() {
				this.$refs.addForm.validate(valid => {
					if (valid) {
						var nodes = this.$refs.tree.getCheckedNodes();
						var purviewCodes = [];
						var childCodes=[]
						var codes={}
						var that=this

						nodes.forEach(function(item) {
							if(item.type == 1){
								//1001
								//childCodes.push(item.id);
								//that.$set(codes,item.id.split('_')[0],"")
								that.$set(codes,item.id)
							} 
						});
						for(let key in codes){
							purviewCodes.push(key);
						}
						this.addForm.purviewCodes = purviewCodes.join(",");
						this.addForm.pageFunCodes=this.pageFunCodesArr.join(',')
						this.addForm.childCodes = childCodes.join(",");
						let formData = this.$util.jsonToForm(this.addForm);
						formData.append("txt_id",this.addForm.roleID);
						this.$axios.post("/backadmin/eslrolesave", formData).then(res => {
							if (res.data.status == 0) {
								//this.$refs.addForm.resetFields() // 表单重置
								this.$message("保存成功!");
								this.$emit("saveCallBack");
							} else {
								this.$message(res.data.msg);
							}
						});
						
					} else {
						return false;
					}
				});
			}
		},
	  async created() {
			this.pageFunCodesDict=JSON.parse(JSON.stringify(await this.getDictInfo('pageFuntion')))
		}
	};
</script>

<style lang="scss" scoped>
	
</style>
